import {createRoot} from 'react-dom/client';
import {collectWebVitals} from './collectWebVitals';
import 'configs/i18n';
import 'index.css';
import {setupSentry} from './setupSentry';
import App from './App';

const IS_PRODUCTION_BUILD = import.meta.env.MODE === 'production';
if (IS_PRODUCTION_BUILD) {
  setupSentry();
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('The root element is not found');
}

const root = createRoot(container);

root.render(<App />);

if (import.meta.env.VITE_APP_WITH_WEB_VITALS === 'true') {
  window.collectWebVitals = collectWebVitals;
}
